import type { Portfolio } from '@/types'
import { AuthTokenExpiredException } from '@pkg/basic'
import { apiClient } from '../../constants'

export const getPortfolios = async (params: {
  getToken: () => Promise<string | null>
}): Promise<readonly Portfolio[]> => {
  const { getToken } = params

  const token = await getToken()
  if (token === null) {
    throw new AuthTokenExpiredException()
  }
  const response = await apiClient.v1.portfolio.$get(undefined, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  if (!response.ok) {
    throw new Error(
      `Failed to get portfolios: ${response.status} ${response.statusText}`,
    )
  }
  return await response.json()
}
